import useForm from './formHook';
import useLoading from './loadingHook';
import useFormValidator from './formValidatorHook';

export default function useLoadingForm(initFormData, asyncHandler, handlerCallback, handleErrCallback, rules, isOptionalForm) {
    const { formData, setFormData, handleChange } = useForm(initFormData);
    const { errorMapping, validate } = useFormValidator(Object.fromEntries(Object.keys(initFormData).map(name => [name, ''])), rules);
    const { loading, loaded, setLoaded, handleLoad, setLoading } = useLoading(asyncHandler, handlerCallback, handleErrCallback);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isOptionalForm) { // If form is optional, we need to at least make sure that everything is filled in prior to validation.
            for (let name of Object.keys(formData)) {
                if (!formData[name]) {
                    return ;
                }
            }
        }
        if (rules) { // Not having rules essentially means opting out of validation.
            if (!loaded && validate(formData)) {
                handleLoad();
            }
        }
        else {
            if (!loaded) {
                handleLoad();
            }
        }
    }

    const handleFormChange = (e) => {
        if (!loading) {
            if (loaded) {
                setLoaded(false);
            }
            handleChange(e);
        }
    }

    return { formData, setFormData, handleChange: handleFormChange, loading, loaded, setLoaded, setLoading, handleSubmit, errorMapping };
}